import { Product } from "@/ui-sdk/types";
import { cloneNode, getProducts } from "../utils";
import { handleEvent } from "@/ui-sdk/components/track/util";
import { cleanName, getPersonaName } from "./util";
import { createElementFromString } from "@/datastore/utils";
import { CDN_URL } from "@/constants/cdn";

const cdn = CDN_URL;
export default async function handleProductList(
  element: HTMLElement,
  insertAfter: string = "",
  //handles: string[] = ["", ""],
): Promise<void> {
  if (window.location.search.includes("filter")) return;
  const handles = [];
  const time = Date.now();
  const isProductPage = window.location.pathname.includes("/products");
  if (isProductPage) return;
  await new Promise((res) => {
    const interval = setInterval(() => {
      const attributes = window.helium.attributes.persona.primary;
      const keys = Object.keys(attributes);
      if (
        keys.length > 35 &&
        attributes.location &&
        attributes.location?.city
      ) {
        clearInterval(interval);
        res(null);
      }
    }, 50);
  });

  let [{ hasVariants, products }, data] = await Promise.all([
    await getMerchandisedHandles(handles),
    await getBrandProducts(),
  ]);

  const details = await Promise.all(
    products.map(
      async (product) =>
        (
          await window.helium.datastore.getProduct({
            id: product.id,
          })
        ).details,
    ),
  );
  try {
    products = details.filter(Boolean).filter((p) => {
      return p.variants.some((v) => {
        return v.availableForSale;
      });
    });
  } catch (e) {
    console.log("Error filtering products", e, "yyyyyyy");
  }
  console.log({ filteredProducts: products });
  // shuffle(handles);

  const existingNode2 = window.helium?.datastore?.memory?.html?.product;

  let querySelector = `[data-helium-name="product-item"]`;
  if (window.helium.productGridQuerySelector) {
    querySelector =
      window.helium.productGridQuerySelector + ` ${querySelector}`;
  }
  const allExistingProductNodes = document.querySelectorAll(querySelector);

  const productsToSkip = 3;

  const existingNode =
    allExistingProductNodes.length > productsToSkip
      ? allExistingProductNodes[productsToSkip]
      : allExistingProductNodes[0];
  if (!existingNode) {
    console.error("No valid 'data-helium-name' attribute found.");
    return;
  }
  const existingNodeHandle = existingNode.getAttribute(
    "data-helium-product-handle",
  );

  try {
    const existingProduct = (
      await window.helium.datastore.getProduct({
        id: existingNodeHandle as string,
      })
    )?.details;

    if (existingProduct) {
      await insertProducts({
        existingProduct,
        insertAfter,
        existingNode,
        products,
        element,
        hasVariant: hasVariants,
      });
      try {
        handleEvent({
          name: "merchandize",
          properties: { category: "" },
        });
      } catch (e) {
        console.log("Error handling merchandize event", e);
      }
    } else {
      console.log("Product not found");
    }
  } catch (e) {
    console.log("Error getting product", e);
  }
}

async function insertProducts({
  existingProduct,
  insertAfter,
  existingNode,
  handles,
  element,
  hasVariant,
  products,
}: {
  existingProduct: Product;
  insertAfter?: string;
  existingNode: HTMLElement;
  handles: string[];
  element: HTMLElement;
  hasVariant: boolean;
  products: Product[];
}) {
  let parentNode = existingNode.parentNode;
  // const products = await getProducts(handles);
  products.forEach((product: Product) => {
    const clonedNode = cloneNode(
      createElementFromString(window.helium.productCard),
      product,
      existingProduct,
      hasVariant,
      {
        componentType: "merchandize",
        eventData: {
          collectionHandle: window.location.pathname.split("/").at(-1),
        },
      },
    );
    parentNode = element;
    try {
      if (insertAfter) {
        const insertElement = document.querySelector(
          `[${PRODUCT_ITEM_HANDLE}="${insertAfter}"]`,
        );
        if (insertElement) {
          parentNode.insertBefore(clonedNode, insertElement.nextSibling);
        } else {
          console.log(`Insert element with handle "${insertAfter}" not found.`);
          parentNode.insertBefore(clonedNode, existingNode);
        }
      } else {
        parentNode.insertBefore(clonedNode, existingNode);
      }
    } catch (e) {
      if (window.location.pathname.includes("merchandising"))
        element.appendChild(clonedNode);
      // throw new Error(e.message);
    }
  });
}

export const PRODUCT_ITEM_HANDLE = "data-helium-product-handle";

// const BACKEND_URL = "https://backend.heliumbuilder.com";
export const BACKEND_URL = "https://dev-backend.up.railway.app";

// let fetchedHandles = undefined;
async function getMerchandisedHandles(
  handles: string[],
): Promise<{ products: Product[]; hasVariants: boolean }> {
  // if (fetchedHandles) {
  //   handles.push(...fetchedHandles);
  //   return fetchedHandles;
  // }
  const windowSearchParams = new URLSearchParams(window.location.search);
  const { type, handle } = window.helium.datastore.current.page;
  const { primary, secondary } = window.helium.attributes.persona;
  const deviceInfo = {
    deviceType: primary.device.type || "desktop",
    deviceos: primary.osName,
    diviceTier: secondary.deviceQuality,
  };
  const locationInfo = {
    country: primary.location?.country,
    city: primary.location?.city ? primary.location?.city?.toLowerCase() : "",
    weather: secondary.weatherCondition,
  };
  const searchInfo = {
    utmName: windowSearchParams.get("utm_name"),
    utmContent: windowSearchParams.get("utm_content"),
    utmMedium: windowSearchParams.get("utm_medium"),
    utmSource: windowSearchParams.get("utm_source"),
  };
  const time = new Date();
  const timeInfo = {
    day: time.getDay(),
    hour: time.getHours(),
  };
  const pageInfo = {
    collection: type === "collection" ? handle : "",
  };
  const brandInfo = {
    orgId: window.helium.brandData.orgId,
    storeId: window.helium.brandData.storeId,
  };
  const browserInfo = {
    browserName: primary.browserName,
  };
  let overrideObj = {};
  if (windowSearchParams.get("merchandize") === "custom") {
    overrideObj = getOverrideObject(windowSearchParams);
  }
  const searchObject = {
    ...timeInfo,
    ...deviceInfo,
    ...searchInfo,
    ...locationInfo,
    ...pageInfo,
    ...brandInfo,
    ...overrideObj,
  };
  Object.keys(searchObject).forEach((val) => {
    if (!searchObject[val]) delete searchObject[val];
  });
  const timer = Date.now();
  console.log({ timer });

  const devPersona = windowSearchParams.get("dev_persona");
  const devCity = windowSearchParams.get("dev_city");
  const city = "new delhi";
  const tier = window.helium.attributes.persona.secondary.cityTier;

  const persona = getPersonaName(
    primary,
    devCity ? devCity : (primary.location?.city ?? "new delhi"),
  );

  const fallbackPersona = getPersonaName(primary, tier);

  const [data, refetchedData] = await Promise.all([
    fetch(
      `${cdn}/${brandInfo.orgId}/merchandising/${decodeURIComponent(pageInfo.collection)}/collections${brandInfo.storeId ? `.${brandInfo.storeId}` : ``}.${persona}.json`,
    )
      .then((res) => res.json())
      .then((data) => {
        // handles.push(...saveProductToMemory(data));
        console.log({ finalTime: Date.now() - timer }, 2);
        return {
          hasVariants: data.hasVariants,
          products: data.list.filter((d) => typeof d.id === "string"),
        };
      })
      .catch((e) => {
        console.log("Error fetching merchandize data from cdn", e);
        return null;
      }),

    fetch(
      `${cdn}/${brandInfo.orgId}/merchandising/${decodeURIComponent(pageInfo.collection)}/collections${brandInfo.storeId ? `.${brandInfo.storeId}` : ``}.${fallbackPersona}.json`,
    )
      .then((res) => res.json())
      .then((data) => {
        // handles.push(...saveProductToMemory(data));
        console.log({ finalTime: Date.now() - timer }, 2);
        return {
          hasVariants: data.hasVariants,
          products: data.list.filter((d) => typeof d.id === "string"),
        };
      })
      .catch((e) => {
        console.log("Error fetching merchandize data from cdn", e);
        return null;
      }),
  ]);

  if (data) {
    return { products: data.products, hasVariants: data.hasVariants || false };
  } else if (refetchedData) {
    return {
      products: refetchedData.products,
      hasVariants: refetchedData.hasVariants || false,
    };
  }

  if (!data.products) {
    await fetch(`${BACKEND_URL}/merchandize/miss`, {
      method: "POST",
      body: JSON.stringify({
        city: locationInfo.city,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  // await fetch(`${BACKEND_URL}/merchandize?${search.toString()}`, {
  //   method: "POST",
  //   body: JSON.stringify({
  //     userData: window.helium.attributes.persona.primary,
  //   }),
  //   headers: {
  //     "Content-Type": "application/json",
  //   },
  // });

  return {};
  // fetchedHandles = handles;
  // return { products: data.products, hasVariants: data.hasVariants || false };
}

const getOverrideObject = (windowSearchParams) => {
  const deviceInfo = {
    deviceType: windowSearchParams.get("device_type"),
    deviceos: windowSearchParams.get("device_os"),
    diviceTier: windowSearchParams.get("device_tier"),
  };
  const locationInfo = {
    country: windowSearchParams.get("country"),
    city: windowSearchParams.get("city"),
    weather: windowSearchParams.get("weather"),
  };
  const searchInfo = {
    utmName: windowSearchParams.get("utm_name"),
    utmContent: windowSearchParams.get("utm_content"),
    utmMedium: windowSearchParams.get("utm_medium"),
    utmSource: windowSearchParams.get("utm_source"),
  };
  const timeInfo = {
    day: windowSearchParams.get("day"),
    hour: windowSearchParams.get("hour"),
  };
  const browserInfo = {
    browserName: windowSearchParams.get("browser_name"),
  };
  const searchObject = {
    ...timeInfo,
    ...deviceInfo,
    ...searchInfo,
    ...locationInfo,
  };
  return searchObject;
};
function shuffle(array) {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {
    // Pick a remaining element...
    const randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }
}
async function getBrandProducts() {
  return;
  const collectionHandle = window.location.pathname.split("/").at(-1);
  const orgId = window.helium.brandData.orgId;
  const storeId = window.helium.brandData.storeId;
  const data = await fetch(
    `${cdn}/${orgId}/collections/${collectionHandle}.json`,
  );
  return (await data.json()) as Promise<
    Record<string, { compareAtPriceRange: number; priceRange: number }>
  >;
}
